<template>
  <div>
    <template v-if="field === 'newapply'">
      <span @click="operate('newapply', rowData)" v-if="rowData.backend_check_status * 1 === 10 || rowData.backend_check_status * 1 === 100">审核</span>
    </template>
    <template v-else-if="field === 'cus_jiu_apply'">
      <span @click="operate('cus_jiu_apply', rowData)" v-if="rowData.backend_check_status * 1 === 40">审核</span>
    </template>
    <template v-else-if="field === 'cus_del_apply'">
      <span @click="operate('cus_del_apply', rowData)" v-if="rowData.backend_check_status * 1 === 70">审核</span>
    </template>
    <template v-else>
      <span @click="operate('revent', rowData)">还原</span>
    </template>
  </div>
</template>
<script>
export default {
  name: 'delAndEdit',
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    operate(type, rowData) {
      this.$emit('on-custom-comp', { type, rowData })
    }
  },
  mounted() {
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/color.scss";
span {
  color: $blue;
  cursor: pointer;
}
</style>
